/**
 * Bootstrap 4 Inits + Handlers
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {

    /*
     * @TODO
     */
    $('.section-page-content .content table').each(function(e){
        $(this).wrap('<div class="table-responsive"></div>');
    });

    SkillsForWales.equalHeights('.event .body');
    SkillsForWales.equalHeights('.event .body h3');

    /*
     * @TODO
     */
    $('.hero-compact').each(function() {
        
        var heroSection   = $(this),
            heroContent   = heroSection.find('.hero-content'),
            innerHeight   = heroContent.innerHeight(),
            sectionHeight = heroSection.innerHeight();

        if (innerHeight < sectionHeight && $(window).width() < 768) {
            heroSection.addClass('is-compact');
            heroContent.on('click', '.hero-more', function(e) {
                $(this).attr('data-state', function(index, attr){
                    return attr == 'plus' ? 'minus' : 'plus';
                });
                $(this).find('span').text(function(index, text) {
                    return text == 'Read more' ? 'Read less' : 'Read more';
                });
                heroSection.toggleClass('is-compact');
                $(this).find('.fas').toggleClass('fa-plus-circle fa-minus-circle');
            });
        }
    });


    /*
     * @TODO
     */
    $(window).on('load',function(){
        var delay = 1500;
        setTimeout(function(){
            if (! Cookies.get('did-survey')) {
                $('#survey-modal').modal('show');
            }
        }, delay);
    });


    $('#survey-modal').on('hide.bs.modal', function (evt) {
        $('#survey-iframe').attr('src', '').fadeToggle('fast', function() {
            $('#survey-iframe').prev().fadeToggle();
        });
        if (Cookies.get('started-survey')) {
            Cookies.remove('started-survey');
            Cookies.set('did-survey', 1, { expires: 365 });
        }
    });


    /*
     * @TODO
     */
    $(document).on('click', '.load-survey', function(evt) {
        evt.preventDefault();
        Cookies.set('started-survey', 1, { expires: 365 });
        var iframe = $('#survey-iframe');
        var survey_url = $(this).attr('href');
        iframe.attr('src', survey_url).prev().fadeToggle('slow', 'linear', function() {
            iframe.fadeToggle('slow', 'linear');
        });
        $(this).addClass('disabled').blur();
        var close_text = $(this).prev().data('close-text');
        $(this).prev().text(close_text);
    });


    /*
     * @TODO
     */
    $(window).resize(function() {
        if ($(window).width() < 768) {
            $('.hero-compact').removeClass('not-compact').addClass('is-compact');
        } else {
            $('.hero-compact').removeClass('is-compact').addClass('not-compact');
        }
    });


    /*
     * @TODO
     */
    $(document).on('click', '.accordion .acc-row .acc-header a', function(e) {
        var closest_row = $(this).closest('.acc-row');
        if (closest_row.hasClass('open')) {
            closest_row.removeClass('open');
        } else {
            $('.acc-row').removeClass('open');
            $(this).closest('.acc-row').toggleClass('open');
        }
    });
});